import { useState, useEffect, useRef } from 'react';
import {
  getMe,
  getAllMovimientos,
  getAllMovimientosPerfil,
} from '../../../service/users/Usuarios';
import { MovimientosModel } from '../models/MovimientosModel';
import { useHistory } from 'react-router-dom';
import { getAllMethod } from '../../../service/paymentMethod/PaymentMethod';
import { SimpleAlert } from '../../../../_mexablock/helpers';
import {
  getAllActivity,
  getAllIndicators,
} from '../../../service/activity/activity';
import {
  getAllConsignment,
  getAllIndicatorsConsignment,
} from '../../../service/consignment/consignment';
import {
  getAllBalance,
  getAllIndicatorsBalance,
} from '../../../service/balance/balance';

export const useGetMe = (realoadInfo: boolean, init: any) => {
  const [user, setUser] = useState<any>(init);
  useEffect(() => {
    const fetchPost = async () => {
      const data = await getMe();
      setUser(data);
    };
    fetchPost();
  }, [realoadInfo]);
  return { user };
};
export const useGetAll = (realoadGrid: number) => {
  const [data, setData] = useState<MovimientosModel[]>([]);
  const [loadingRequest, setLoadingRequest] = useState(0);
  const history = useHistory();
  useEffect(() => {
    const fetchPost = async () => {
      const res = await getAllMovimientos()
        .then()
        .catch((error) => {
          // history.push('/error/500');
          SimpleAlert('Falta info', 3000, 'error');
        });
      if (res) {
        setData(res.rows);
        setLoadingRequest(1);
      }
    };
    if (realoadGrid) {
      fetchPost();
    }
  }, [realoadGrid]);
  return { data, loadingRequest };
};

export const useGetAllMovements = (realoadGrid: number) => {
  const [data, setData] = useState<any[]>([]);
  const [loadingRequest, setLoadingRequest] = useState(0);
  const history = useHistory();
  useEffect(() => {
    const fetchPost = async () => {
      const res = await getAllMovimientosPerfil()
        .then()
        .catch((error) => {
          SimpleAlert('Falta info', 3000, 'error');
        });
      if (res) {
        setData(res);
        setLoadingRequest(1);
      }
    };
    if (realoadGrid) {
      fetchPost();
    }
  }, [realoadGrid]);
  return { data, loadingRequest };
};

export const useGetAllMethod = (realoadGrid: number) => {
  const [data, setData] = useState<any>(null);
  const [loadingRequest, setLoadingRequest] = useState(false);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const res = await getAllMethod();
        if (res) {
          setData(res);
          setLoadingRequest(true);
        }
      } catch (error) {
        SimpleAlert('Falta info', 3000, 'error');
      }
    };

    if (realoadGrid) {
      fetchPost();
    }
  }, [realoadGrid]);

  return { data, loadingRequest };
};
// -------- Tabla de actividad -------------
export const useGetAllActivity = (realoadGrid: number, year: string) => {
  const [data, setData] = useState<any[]>([]);
  const [loadingRequest, setLoadingRequest] = useState(0);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const res = await getAllActivity(year);
        if (res) {
          setData(res);
          setLoadingRequest(1);
        }
      } catch (error) {
        SimpleAlert('Falta info', 3000, 'error');
      }
    };

    if (realoadGrid) {
      fetchPost();
    }
  }, [realoadGrid]);

  return { data, loadingRequest };
};
//-------- Termino tabla actividad -----------
export const useGetAllIndicators = (realoadGrid: number, filter: any) => {
  const [dataIndicators, setDataIndicators] = useState<any>(null);
  const [loadingRequestIndicators, setLoadingRequestIndicators] =
    useState(false);
  const filterRef = useRef<string>();

  useEffect(() => {
    const filterString = JSON.stringify(filter);
    
    // Evitar llamadas duplicadas comparando el string del filtro
    if (filterRef.current === filterString) return;
    filterRef.current = filterString;
    
    const fetchPost = async () => {
      try {
        const res = await getAllIndicators(filter);
        if (res) {
          const mapped = {
            activations: res.activations?.total ?? 0,
            activations_number: res.activations?.count ?? 0,
            portabilities: res.portabilities?.total ?? 0,
            portabilities_number: res.portabilities?.count ?? 0,
            recharges: res.recharges?.total ?? 0,
            recharges_number: res.recharges?.count ?? 0,
            globalTotal: res.globalTotal ?? 0,
            oldest_year: res.oldest_year ?? null,
          };
          setDataIndicators(mapped);
          setLoadingRequestIndicators(true);
        }
      } catch (error: any) {
        let message = 'Error inesperado. Intenta de nuevo.';

        if (error.response) {
          // El servidor respondió con un status de error
          if (error.response.data?.message) {
            message = error.response.data.message;
          } else if (typeof error.response.data === 'string') {
            message = error.response.data;
          } else {
            message = `Error ${error.response.status}: ${error.response.statusText}`;
          }
        } else if (error.request) {
          // La petición salió pero no hubo respuesta
          message = 'No hubo respuesta del servidor. Revisa tu conexión.';
        } else {
          // Error al armar la petición (antes de enviarla)
          message = error.message || message;
        }

        SimpleAlert(message, 3000, 'error');
      }
    };

    if (realoadGrid) {
      fetchPost();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [realoadGrid, JSON.stringify(filter)]);

  return { dataIndicators, loadingRequestIndicators };
};

// -------- Tabla de saldo -------------
export const useGetAllBalance = (realoadGrid: number, year: string) => {
  const [data, setData] = useState<any[]>([]);
  const [loadingRequest, setLoadingRequest] = useState(0);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const res = await getAllBalance(year);
        if (res) {
          setData(res);
          setLoadingRequest(1);
        }
      } catch (error) {
        SimpleAlert('Falta info', 3000, 'error');
      }
    };

    if (realoadGrid) {
      fetchPost();
    }
  }, [realoadGrid]);

  return { data, loadingRequest };
};
//-------- Termino tabla saldo -----------------
//-------- Tabla consignación ------------------
export const useGetAllConsig = (realoadGrid: number, year: string) => {
  const [data, setData] = useState<any[]>([]);
  const [loadingRequest, setLoadingRequest] = useState(0);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const res = await getAllConsignment(year);
        if (res) {
          setData(res);
          setLoadingRequest(1);
        }
      } catch (error) {
        SimpleAlert('Falta info', 3000, 'error');
      }
    };

    if (realoadGrid) {
      fetchPost();
    }
  }, [realoadGrid]);

  return { data, loadingRequest };
};
//-------- Termino tabla consignacion ----------
export const useGetAllIndicatorsBalance = (realoadGrid: number) => {
  const [dataIndicators, setDataIndicators] = useState<any>(null);
  const [loadingRequestIndicators, setLoadingRequestIndicators] =
    useState(false);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const res = await getAllIndicatorsBalance();
        if (res) {
          setDataIndicators(res);
          setLoadingRequestIndicators(true);
        }
      } catch (error) {
        SimpleAlert('Falta info', 3000, 'error');
      }
    };

    if (realoadGrid) {
      fetchPost();
    }
  }, [realoadGrid]);

  return { dataIndicators, loadingRequestIndicators };
};

export const useGetAllIndicatorsConsignment = (realoadGrid: number) => {
  const [dataIndicators, setDataIndicators] = useState<any>(null);
  const [loadingRequestIndicators, setLoadingRequestIndicators] =
    useState(false);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const res = await getAllIndicatorsConsignment();
        if (res) {
          setDataIndicators(res);
          setLoadingRequestIndicators(true);
        }
      } catch (error) {
        SimpleAlert('Falta info', 3000, 'error');
      }
    };

    if (realoadGrid) {
      fetchPost();
    }
  }, [realoadGrid]);

  return { dataIndicators, loadingRequestIndicators };
};
